import { Pipe, PipeTransform, SecurityContext, inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { renderMarkdown } from '../../../utils/MarkdownUtils';

@Pipe({ name: 'agentMarkdown', standalone: true })
export class AgentMarkdownPipe implements PipeTransform {
  private readonly sanitizer = inject(DomSanitizer);

  transform(markdown: string): string {
    return this.sanitizer.sanitize(SecurityContext.HTML, renderMarkdown(markdown || '')) || '';
  }
}
